import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  // Hardcoded date format; this can later be fetched from organization settings
  private dateFormat: string = 'MM/dd/YYYY'; // Example default

  // Method to get the date format (this will fetch from settings later)
  public getDateFormat(): string {
    return this.dateFormat;
  }

  // Method to format the date based on the current format
  formatDate(date: Date | string): string {
    if (!date) return '';
    const options: Intl.DateTimeFormatOptions = this.getDateFormatOptions();
    return new Date(date).toLocaleDateString(undefined, options);
  }

  private getDateFormatOptions(): Intl.DateTimeFormatOptions {
    return {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    };
  }
}
